import { useEffect, useState } from 'react';
import enLocale from 'date-fns/locale/en-GB';
import plLocale from 'date-fns/locale/pl';
import skLocale from 'date-fns/locale/sk';

import { DEFAULT_LANG, locale, SITE_LANGUAGES } from '../locale/locale';
import { LocaleLang, LocaleObject } from '../locale/locale-types';

const defaultLanguageFallback = (lang: LocaleLang): LocaleLang =>
  SITE_LANGUAGES.includes(lang) ? lang : DEFAULT_LANG;

export const useLocale = (): {
  Message: LocaleObject;
  language: LocaleLang;
  localeObject: Locale;
} => {
  const [language, setLanguage] = useState<LocaleLang>(
    defaultLanguageFallback(document.documentElement.lang as LocaleLang)
  );

  // if hasn't changed correctly, add Mutation Observer
  useEffect(() => {
    setLanguage(
      defaultLanguageFallback(document.documentElement.lang as LocaleLang)
    );
  }, []);

  return {
    Message: locale[language],
    language,
    localeObject:
      language === 'sk'
        ? skLocale
        : language === 'en'
        ? enLocale
        : language === 'pl'
        ? plLocale
        : skLocale,
  };
};
